import { lazy } from 'react'

import Valori from './valori'

export default {
    path: '/tabelle',
    title: 'Tabelle',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:tabellaId',
            title: 'Tabella: {{params.tabellaId}}',
            drawer: false,
            component: lazy(() => import('./detail')),
            pages: [Valori]
        }
    ]
}